import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Sirve si recién empiezo a dar clases de topografía?',
    a: 'Sí. El Tomo 1 arranca desde la presentación de la asignatura y el primer día de clase. El sistema está pensado tanto para docentes que empiezan como para los que quieren reorganizar y profesionalizar su material después de años de enseñanza.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Una vez confirmado el pago recibís un link de descarga inmediata a tu email. Todo en formato PDF de alta calidad, optimizado para imprimir y para proyectar. Las Plantillas Excel llegan en formato .xlsx editable.'
  }, {
    q: '¿El Pack de Presentaciones es necesario?',
    a: 'Depende de tu dinámica de clase. Si enseñás con proyector o TV, el Pack de Presentaciones te ahorra horas de armado y te da un nivel visual profesional inmediato. Si preferís trabajar solo con PDF, el Megapack base ya es completo.'
  }, {
    q: '¿Cuánto tiempo lleva implementarlo?',
    a: 'Podés usar el primer material el mismo día que lo descargás. Está todo listo para imprimir, proyectar o compartir. No necesitás adaptarlo — aunque podés editarlo si querés personalizarlo.'
  }, {
    q: '¿La garantía es real?',
    a: '100% real. Si en 7 días no estás conforme, escribinos y te devolvemos el dinero completo. Sin preguntas, sin formularios. Así de simple.'
  }, {
    q: '¿Es aplicable a cualquier nivel técnico?',
    a: 'Sí. Funciona para institutos técnicos, universidades, escuelas agrarias y cualquier institución donde se enseñe topografía, agrimensura o materias afines. El contenido está organizado de modo que podés seleccionar lo que aplica a tu programa.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-[#06140d]" data-id="element-48">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-49">
        <h2 className="text-3xl font-extrabold text-center text-white mb-12" data-id="element-50">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-51">
          {faqs.map((faq, i) => <div key={i} className="border border-[#1a3d2c] rounded-2xl overflow-hidden bg-[#0c241a]/60" data-id="element-52">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-400 hover:bg-[#0a1f15]/40 transition-colors" aria-expanded={openIndex === i} data-id="element-53">
                <span className="font-bold text-white pr-4" data-id="element-54">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-slate-400 transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-55" />
              </button>

              <AnimatePresence data-id="element-56">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-57">
                    <div className="px-6 pb-5 text-slate-300 leading-relaxed border-t border-[#1a3d2c] pt-3" data-id="element-58">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}